// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dgNKEmaZ0D1fmg {
  background-color: var(--ds-background-neutral, #091e420f);
  display: flex;
  width: 24px;
  height: 24px;
  margin-right: 0;
  padding: 2px;
  border-radius: 3px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  text-decoration: none;
  cursor: pointer;
  transition-property: background-color, border-color, box-shadow;
  transition-duration: 85ms;
  transition-timing-function: ease;
}
.dgNKEmaZ0D1fmg:hover,
.dgNKEmaZ0D1fmg:focus {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  color: var(--ds-text, #172b4d);
}
a.dgNKEmaZ0D1fmg:hover,
a.dgNKEmaZ0D1fmg:focus {
  text-decoration: none;
}
.dgNKEmaZ0D1fmg:active {
  background-color: var(--ds-background-neutral-pressed, #091e424f);
  color: var(--ds-text, #172b4d);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTagAdd": `dgNKEmaZ0D1fmg`
};
export default ___CSS_LOADER_EXPORT___;
